import { EnumOption } from "./enum-option"

export const JobApplicationMethod = {
    Online: 0,
    Email: 1,
    Other: 2,
}

export const JobApplicationMethodList: EnumOption[] = [
    { value: JobApplicationMethod.Online, label: 'Online' },
    { value: JobApplicationMethod.Email, label: 'Email' },
    { value: JobApplicationMethod.Other, label: 'Other' },
]
